export const environment = {
  //General
  title: 'Oauth',
  production: false,
  version: '3.0.0-beta',
  environment_variable: 'staging',
  storageType: 1,
  mock_use_get_only: false,

  //Client App URLs
  oauth_url: 'https://login.corp.aksia.com:44313',
  max_url: 'https://max-staging.aksia.com',
  o2_url: 'http://o2.corp.aksia.com:4200',
  cedric_url: 'https://cedric.corp.aksia.com:443',
  origin_url: 'https://origin.corp.aksia.com:4203',
  legacy_url: 'https://cedric.aksia.com',

  microservices_api_url: 'https://identity-api-staging.aksia.com',
  cedric_api_url: 'https://cedric-api-staging.aksia.com',
  report_service_url: 'http://reporting.corp.aksia.com',
  mock_api_url: 'http://cedric.corp.aksia.com:4200/mock/database',

  //Other URLs
  max_redirect_url:
    'https://max-staging.aksia.com/Default.aspx?redirectUrl=https://cedric.corp.aksia.com:443',
  google_api_url:
    'https://maps.googleapis.com/maps/api/js?loading=async&libraries=places&callback=initMap&language=en-US',

  //Security
  omit_user_groups: false,
  mock_user: undefined,

  //Mirrors LoginSecurity:ResetPasswordTokenValidMinutes on the identity server. */
  reset_password_token_valid_minutes: 30,
};
